import { StyleSheet, Platform } from 'react-native';
import { BREAKPOINTS, getResponsiveValue, createResponsiveStyle } from './breakpoints';
import { colors } from './theme';
export const profileStyles = StyleSheet.create({
  audioWaveContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    marginBottom: 4,
  },
  audioWave: {
    width: 3,
    backgroundColor: '#ffffff',
    borderRadius: 1.5,
  },
 container: {
  flex: 1,
  ...(Platform.OS === 'web' && {
   position: 'relative',
   left: 0,
   right: 0,
  }),
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: '100%',
 },
 backgroundImage: {
  flex: 1,
  width: '100%',
  height: '100%',
  ...(Platform.OS === 'web' && {
   position: 'fixed',
   top: 0,
   left: 0,
   right: 0,
   bottom: 0,
  }),
 },
 overlay: {
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: 0,
  minHeight: '100%',
  minWidth: '100%',
 },
 profileGrid: {
  width: '100%',
  maxWidth: getResponsiveValue({
    mobile: '100%',
    tablet: '100%',
    laptop: '100%',
    desktop: '100%',
  }),
  display: 'flex',
  flexDirection: getResponsiveValue({
    mobile: 'column',
    tablet: 'column',
    medium: 'column',
    laptop: 'row',
    desktop: 'row',
  }),
  alignItems: getResponsiveValue({
    mobile: 'center',
    tablet: 'center',
    medium: 'center',
    laptop: 'flex-start',
    desktop: 'flex-start',
  }),
  justifyContent: getResponsiveValue({
    mobile: 'center',
    tablet: 'center',
    laptop: typeof window !== 'undefined' && window.innerWidth <= 820 ? 'center' : 'space-between',
    desktop: 'space-between',
  }),
  gap: getResponsiveValue({
    mobile: 15,
    tablet: 20,
    laptop: 20,
    desktop: 20,
  }),
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingHorizontal: getResponsiveValue({
    mobile: 0,
    tablet: 10,
    medium: 10,
    laptop: 20,
    desktop: 20,
  }),
  paddingTop: getResponsiveValue({
    mobile: 0,
    tablet: 0,
    laptop: 20,
    desktop: 20,
  }),
 },
 profileColumnLeft: {
  flex: 1,
  width: getResponsiveValue({
    mobile: '100%',
    tablet: '100%',
    medium: '100%',
    laptop: '48.5%',
    desktop: '48.5%',
  }),
  flexDirection: getResponsiveValue({
    mobile: 'column',
    tablet: 'column',
    medium: 'row',
    laptop: 'column',
    desktop: 'column',
  }),
  maxWidth: getResponsiveValue({
    mobile: '100%',
    tablet: '100%',
    medium: '100%',
    laptop: '35%',
    desktop: '35%',
  }),
  minWidth: getResponsiveValue({
    mobile: 'none',
    tablet: 'none',
    medium: 'none',
    laptop: 300,
    desktop: 300,
  }),
  gap: getResponsiveValue({
    mobile: 20,
    tablet: 20,
    medium: 10,
    laptop: 20,
    desktop: 20,
  }),
  alignItems: getResponsiveValue({
    mobile: 'center',
    tablet: 'center',
    laptop: 'flex-start',
    desktop: 'flex-start',
  }),
  marginBottom: getResponsiveValue({
    mobile: 0,
    tablet: 25,
    laptop: 20,
    desktop: 20,
  }),
 },
 profileColumnRight: {
  flex: getResponsiveValue({
    mobile: 'none',
    tablet: 'none',
    medium: 'none',
    laptop: 1,
    desktop: 1,
  }),
  width: getResponsiveValue({
    mobile: '100%',
    tablet: '100%',
    medium: '100%',
    laptop: '60%',
    desktop: '60%',
  }),
  minWidth: getResponsiveValue({
    mobile: 'none',
    tablet: 'none',
    medium: 'none',
    laptop: 300,
    desktop: 300,
  }),
  height: getResponsiveValue({
    mobile: 'auto',
    tablet: 'auto',
    medium: 'auto',
    laptop: '100%',
    desktop: '100%',
  }),
  flexDirection: getResponsiveValue({
    mobile: 'column',
    tablet: 'column',
    medium: 'column',
    laptop: 'column',
    desktop: 'column',
  }),
  alignItems: getResponsiveValue({
    mobile: 'center',
    tablet: 'center',
    laptop: typeof window !== 'undefined' && window.innerWidth <= 820 ? 'center' : 'flex-start',
    desktop: 'flex-start',
  }),
  marginBottom: getResponsiveValue({
    mobile: 0,
    tablet: 0,
    medium: 0,
    laptop: 20,
    desktop: 20,
  }),
  alignSelf: getResponsiveValue({
    mobile: 'center',
    tablet: 'auto',
    laptop: 'auto',
    desktop: 'auto',
  }),
  marginTop: getResponsiveValue({
    mobile: 10,
    tablet: 10,
    medium: 10,
    laptop: 'none',
    desktop: 'none',
  }),
  gap: getResponsiveValue({
    mobile: 0,
    tablet: 0,
    medium: 0,
    laptop: 20,
    desktop: 20,
  }),
 },

 profileTopLeftCard: {
  position: 'relative',
  width: getResponsiveValue({
    mobile: '90vw',
    tablet: '95%',
    medium: '48%',
    laptop: '100%',
    desktop: '100%',
  }),
  backgroundColor: '#EFF80D',
  borderRadius: 10,
  padding: getResponsiveValue({
    mobile: 15,
    tablet: 20,
    laptop: 25,
    desktop: 30,
  }),
  alignItems: 'center',
  backdropFilter: 'blur(20px)',
  ...(Platform.OS === 'web' ? { boxShadow: '0 4px 8px rgba(0,0,0,0.25)' } : {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
  }),
  marginBottom: getResponsiveValue({
    mobile: 15,
    tablet: 20,
    laptop: 20,
    desktop: 20,
  }),
 },
 communityButton: {
  position: 'absolute',
  top: 10,
  right: 10,
  padding: 10,
  zIndex: 1000,
  backgroundColor: 'rgba(255, 255, 255, 0.3)',
  borderRadius: 10,
  borderWidth: 0,
  transition: 'all 0.3s ease',
  ...(Platform.OS === 'web' && {
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
    cursor: 'pointer',
    transform: 'translateY(-2px)',
    opacity: 1,
  }
})
},

 profileTopRightCard: {
  width: getResponsiveValue({
    mobile: '90vw',
    tablet: '95%',
    laptop: '100%',
    desktop: '100%',
  }),
  backgroundColor: 'rgba(255,255,255,0.1)',
  borderRadius: 10,
  padding: getResponsiveValue({
    mobile: 15,
    tablet: 20,
    laptop: 20,
    desktop: 20,
  }),
  alignItems: 'center',
  backdropFilter: 'blur(20px)',
  ...(Platform.OS === 'web' ? { boxShadow: '0 4px 8px rgba(0,0,0,0.25)' } : {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
  }),
  minHeight: getResponsiveValue({
    mobile: 350,
    tablet: 350,
    laptop: 400,
    desktop: 400,
  }),
  maxHeight: getResponsiveValue({
    mobile: 350,
    tablet: 350,
    laptop: 400,
    desktop: 400,
  }),
  minWidth: getResponsiveValue({
    mobile: '95%',
    tablet: 600,
    laptop: 700,
    desktop: 700,
  }),
 },

 profileBottomLeftCard: {
  width: '100%',
  backgroundColor: '#F7EEEE',
  borderRadius: 10,
  overflow: 'visible',
  zIndex: 1000,
  position: 'relative',
  padding: getResponsiveValue({
    mobile: 15,
    tablet: 20,
    laptop: 25,
    desktop: 30,
  }),
  alignItems: 'stretch',
  backdropFilter: 'blur(20px)',
  ...(Platform.OS === 'web' ? { boxShadow: '0 4px 8px rgba(0,0,0,0.25)' } : {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
  }),
  minHeight: getResponsiveValue({
    mobile: 'auto',
    tablet: 'auto',
    laptop: 'auto',
    desktop: 'auto',
  }),
  maxHeight: 'none',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  borderWidth: 3,
  borderColor: '#4AA2C8',
  borderStyle: 'solid',
  height: 'auto',
  flex: 1,
 },




 profileBottomRightCard: {
  width: getResponsiveValue({
    mobile: '90vw',
    tablet: '95%',
    laptop: '100%',
    desktop: '100%',
  }),
  backgroundColor: 'rgba(255,255,255,0.1)',
  borderRadius: 10,
  padding: getResponsiveValue({
    mobile: 15,
    tablet: 10,
    laptop: 20,
    desktop: 20,
  }),
  alignItems: 'center',
  backdropFilter: 'blur(20px)',
  ...(Platform.OS === 'web' ? {
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  } : {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
  }),
  borderWidth: 3,
  borderColor: '#434252',
  borderStyle: 'solid',
  ...(Platform.OS === 'web' && {
    minWidth: getResponsiveValue({
      mobile: '90vw',
      tablet: '95%',
      laptop: 700,
      desktop: 700,
    }),
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  }),
  marginBottom: getResponsiveValue({
    mobile: 20,
    tablet: 20,
    laptop: typeof window !== 'undefined' && window.innerWidth <= 820 ? 20 : 0,
    desktop: 0,
  }),
 },





 profileImageContainer: {
  position: 'relative',
  width: 150,
  height: 150,
  borderRadius: 75,
  overflow: 'hidden',
  marginBottom: 10,
  cursor: 'pointer',
 },
 profileImage: {
  width: '100%',
  height: '100%',
  borderRadius: 75,
 },
 profileImageOverlay: {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  justifyContent: 'center',
  alignItems: 'center',
  opacity: 0,
  transition: 'opacity 0.3s ease',
  ...(Platform.OS === 'web' && {
    cursor: 'pointer',
    ':hover': {
      opacity: 1,
    }
  }),
 },
 profileImageOverlayHovered: {
  opacity: 1,
 },
 profileImageOverlayText: {
  color: 'white',
  fontSize: 14,
  textAlign: 'center',
  padding: 10,
  fontFamily: 'VastagoGrotesk',
  fontWeight: '500',
 },
 editPhotoOverlay: {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'opacity 0.2s ease-in-out',
  cursor: 'pointer',
 },
 editPhotoText: {
  color: 'white',
  fontFamily: 'VastagoGrotesk',
  fontWeight: '500',
  fontSize: 16,
  textAlign: 'center',
  textShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)',
  padding: 10,
  whiteSpace: 'nowrap',
 },
 cardTitle: {
  fontFamily: 'VastagoGrotesk',
  fontWeight: '700',
  fontSize: Platform.OS === 'web' ? 24 : 20,
  color: colors.purpleReplacement,
  textAlign: 'center',
  marginBottom: 10,
  textShadow: Platform.OS === 'web' ? '0px 2px 2px rgba(0,0,0,0.25)' : undefined,
 },
 mediaImage: {
  width: getResponsiveValue({
    mobile: '100%',
    tablet: '48%',
    laptop: '48%',
    desktop: '48%',
  }),
  height: getResponsiveValue({
    mobile: 200,
    tablet: 150,
    laptop: 150,
    desktop: 150,
  }),
  borderRadius: 10,
  marginBottom: 10,
 },
 onlineStatus: {
  position: 'absolute',
  right: 10,
  top: 10,
  width: 12,
  height: 12,
  borderRadius: 6,
  backgroundColor: '#2ecc71',
  borderWidth: 2,
  borderColor: 'white',
 },
 profileName: {
  fontFamily: 'VastagoGrotesk',
  fontWeight: '700',
  fontSize: getResponsiveValue({
    mobile: 24,
    tablet: 28,
    laptop: 32,
    desktop: 32,
  }),
  color: 'white',
  marginTop: 15,
  textAlign: 'center',
 },
 profileOccupation: {
  fontFamily: 'VastagoGrotesk',
  fontWeight: '400',
  fontSize: getResponsiveValue({
    mobile: 10,
    tablet: 12,
    laptop: 12,
    desktop: 12,
  }),
  color: '#ff878c',
  textAlign: 'center',
  marginBottom: 0,
  textShadow: Platform.OS === 'web' ? '0px 1px 1px rgba(0,0,0,0.25)' : undefined,
 },
 profileStats: {
  flexDirection: 'row',
  justifyContent: 'space-around',
  width: '100%',
  marginTop: 5,
  marginBottom: 10,
 },
 profileStatText: {
  fontFamily: 'VastagoGrotesk',
  fontWeight: '400',
  fontSize: Platform.OS === 'web' ? 14 : 12,
  color: 'white',
  textShadow: Platform.OS === 'web' ? '0px 2px 2px rgba(0,0,0,0.25)' : undefined,
 },
 verificationBadge: {
  position: 'absolute',
  left: 150,
  top: 40,
  width: 15,
  height: 15,
  zIndex: 2,
  transition: 'all 0.3s ease',
 },
 verificationButton: {
  paddingVertical: 8,
  paddingHorizontal: 16,
  borderRadius: 20,
  marginTop: 10,
  marginBottom: 10,
  alignSelf: 'center',
  transition: 'all 0.3s ease',
  ...(Platform.OS === 'web' && {
    cursor: 'pointer',
    ':hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
    }
  }),
 },
 verificationButtonText: {
  color: '#ffffff',
  fontFamily: 'VastagoGrotesk',
  fontWeight: '500',
  fontSize: 16,
  textAlign: 'center',
 },
 verificationStatus: {
  fontFamily: 'VastagoGrotesk',
  fontWeight: '400',
  fontSize: 14,
  textAlign: 'center',
  marginBottom: 5,
  color: '#ffd700',
 },
 verificationApproved: {
  color: '#0bb5df',
 },
 verificationPending: {
  color: '#ffd700',
 },
 inputGroup: {
  width: '100%',
  position: 'relative',
  zIndex: 1,
  marginBottom: getResponsiveValue({
    mobile: 20,
    tablet: 15,
    laptop: 15,
    desktop: 15,
  }),
 },
 inputLabel: {
  fontFamily: 'VastagoGrotesk',
  fontWeight: '500',
  fontSize: getResponsiveValue({
    mobile: 16,
    tablet: 16,
    laptop: 16,
    desktop: 16,
  }),
  color: '#434252',
  marginBottom: 5,
  textShadow: 'none',
 },
 profileInput: {
  backgroundColor: '#434252',
  borderRadius: 15,
  padding: getResponsiveValue({
    mobile: 12,
    tablet: 10,
    laptop: 12,
    desktop: 12,
  }),
  color: 'white',
  fontFamily: 'VastagoGrotesk',
  fontWeight: '400',
  fontSize: getResponsiveValue({
    mobile: 16,
    tablet: 15,
    laptop: 16,
    desktop: 16,
  }),
  width: '100%',
  minHeight: 40,
  height: 'auto',
  resize: 'none',
  ...(Platform.OS === 'web' && {
    outlineStyle: 'none',
    border: 'none',
  }),
 },
 buttonText: {
  color: '#ffffff',
  fontFamily: 'VastagoGrotesk',
  fontWeight: '500',
  fontSize: Platform.OS === 'web' ? 18 : 14,
 },
 placeholderText: {
  fontFamily: 'VastagoGrotesk',
  fontWeight: '400',
  fontSize: Platform.OS === 'web' ? 16 : 14,
  color: '#ffffff80',
  textAlign: 'center',
  marginTop: 20,
 },
 signOutButton: {
  backgroundColor: 'rgba(255,59,48,0.2)',
  padding: Platform.OS === 'web' ? 15 : 12,
  borderRadius: 20,
  borderTopRightRadius: 0,
  borderBottomLeftRadius: 0,
  width: '100%',
  alignItems: 'center',
  cursor: 'pointer',
  marginTop: 'auto',
  marginBottom: 10,
 },
 signOutText: {
  color: '#ff3b30',
  fontFamily: 'VastagoGrotesk',
  fontWeight: '500',
  fontSize: Platform.OS === 'web' ? 18 : 14,
  textAlign: 'center',
 },
 tabContainer: {
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  marginBottom: 0,
  paddingBottom: 4,
  gap: 2,
 },
 tab: {
  paddingVertical: 10,
  paddingHorizontal: 20,
  marginRight: 10,
  borderBottomWidth: 2,
  borderBottomColor: 'transparent',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
 },
 tabActive: {
  borderBottomWidth: 2,
 },
 tabText: {
  fontFamily: 'VastagoGrotesk',
  fontWeight: '500',
  fontSize: 16,
  color: 'white',
  opacity: 0.7,
  transition: 'all 0.3s ease',
 },
 tabTextActive: {
  opacity: 1,
 },
 selectContainer: {
  position: 'relative',
  width: '100%',
 },
 '@global': {
  'select': {
   '-webkit-appearance': 'none',
   '-moz-appearance': 'none',
   appearance: 'none',
   fontFamily: 'VastagoGrotesk',
   fontWeight: '400',
   outlineStyle: 'none',
  },
  'select::-ms-expand': {
   display: 'none',
  },
  'select option': {
   fontFamily: 'VastagoGrotesk',
   fontWeight: '400',
   fontSize: 16,
   padding: 10,
  },
  'select:focus': {
   borderColor: '#0bb5df',
   boxShadow: '0 0 0 2px rgba(11, 181, 223, 0.2)',
  },
  'input::placeholder': {
    color: 'rgba(255, 255, 255, 0.5)',
  },
 },
 userTypeIndicator: {
  width: 12,
  height: 12,
  borderRadius: 6,
  position: 'absolute',
  right: 35,
  top: '50%',
  transform: 'translateY(-50%)',
 },

 userTypeText: {
  fontFamily: 'VastagoGrotesk',
  fontWeight: '400',
  fontSize: getResponsiveValue({
    mobile: 14,
    tablet: 16,
    laptop: 18,
    desktop: 18,
  }),
  textAlign: 'center',
  textShadow: Platform.OS === 'web' ? '0px 1px 1px rgba(0,0,0,0.25)' : undefined,
 },

 occupationContainer: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 5,
  gap: 5,
 },
  occupationInput: {
  fontFamily: 'VastagoGrotesk',
  fontWeight: '400',
  fontSize: getResponsiveValue({
    mobile: 14,
    tablet: 16,
    laptop: 18,
    desktop: 18,
  }),
  color: '#ff878c',
  textAlign: 'center',
  textShadow: Platform.OS === 'web' ? '0px 1px 1px rgba(0,0,0,0.25)' : undefined,
  backgroundColor: 'transparent',
  border: 'none',
  outlineStyle: 'none',
  padding: 0,
  margin: 0,
  minWidth: '100%',
 },
  occupationInputBottom: {
  fontFamily: 'VastagoGrotesk',
  fontWeight: '400',
  fontSize: getResponsiveValue({
    mobile: 14,
    tablet: 16,
    laptop: 18,
    desktop: 18,
  }),
  color: '#ff878c',
  textAlign: 'left',
  textShadow: Platform.OS === 'web' ? '0px 1px 1px rgba(0,0,0,0.25)' : undefined,
  backgroundColor: 'transparent',
  border: 'none',
  outlineStyle: 'none',
  paddingLeft: 5,
  margin: 0,
  
 },
 atSymbol: {
  fontFamily: 'VastagoGrotesk',
  fontWeight: '400',
  fontSize: getResponsiveValue({
    mobile: 14,
    tablet: 16,
    laptop: 18,
    desktop: 18,
  }),
  color: '#ff878c',
  textAlign: 'center',
  textShadow: Platform.OS === 'web' ? '0px 1px 1px rgba(0,0,0,0.25)' : undefined,
 },
 profileRightCard: {
  width: getResponsiveValue({
    mobile: '95%',
    tablet: '95%',
    laptop: '100%',
    desktop: '100%',
  }),
  backgroundColor: 'rgba(255,255,255,0.1)',
  borderRadius: 10,
  padding: getResponsiveValue({
    mobile: 15,
    tablet: 20,
    laptop: 25,
    desktop: 30,
  }),
  alignItems: 'flex-start',
  backdropFilter: 'blur(20px)',
  ...(Platform.OS === 'web' ? { boxShadow: '0 4px 8px rgba(0,0,0,0.25)' } : {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
  }),
 },
 tabButton: {
  paddingVertical: 10,
  paddingHorizontal: getResponsiveValue({
    mobile: 15,
    tablet: 20,
    laptop: 20,
    desktop: 20,
  }),
  borderRadius: 8,
  marginRight: 10,
  marginBottom: 10,
  backgroundColor: '#434252',
  transition: 'all 0.2s ease',
  borderWidth: 2,
  borderColor: 'transparent',
  ...(Platform.OS === 'web' && {
    ':hover': {
      transform: 'translateY(-2px)',
    }
  }),
 },
 tabButtonText: {
  color: 'white',
  fontFamily: 'VastagoGrotesk',
  fontSize: getResponsiveValue({
    mobile: 14,
    tablet: 16,
    laptop: 16,
    desktop: 16,
  }),
  transition: 'color 0.2s ease',
 },
 mediaGrid: {
  display: Platform.OS === 'web' ? 'grid' : undefined,
  gridTemplateColumns: getResponsiveValue({
    mobile: 'repeat(2, 1fr)',
    tablet: 'repeat(2, 1fr)',
    laptop: 'repeat(3, 1fr)',
    desktop: 'repeat(3, 1fr)',
  }),
  gap: getResponsiveValue({
    mobile: 10,
    tablet: 15,
    laptop: 15,
    desktop: 15,
  }),
  width: getResponsiveValue({
    mobile: '95%',
    tablet: '95%',
    laptop: '100%',
    desktop: '100%',
  }),
  flexDirection: Platform.OS === 'web' ? undefined : 'row',
  flexWrap: Platform.OS === 'web' ? undefined : 'wrap',
  justifyContent: 'flex-start',
  padding: getResponsiveValue({
    mobile: 10,
    tablet: 0,
    laptop: 0,
    desktop: 0,
  }),
  maxHeight: getResponsiveValue({
    mobile: 400,
    tablet: 400,
    laptop: 'none',
    desktop: 'none',
  }),
  overflowY: 'auto',
 },
 savedVenuesGrid: {
  display: Platform.OS === 'web' ? 'grid' : undefined,
  gridTemplateColumns: getResponsiveValue({
    mobile: 'repeat(2, 1fr)',
    tablet: 'repeat(2, 1fr)',
    laptop: 'repeat(3, 1fr)',
    desktop: 'repeat(3, 1fr)',
  }),
  gap: getResponsiveValue({
    mobile: 10,
    tablet: 15,
    laptop: 15,
    desktop: 15,
  }),
  width: getResponsiveValue({
    mobile: '95%',
    tablet: '95%',
    laptop: '100%',
    desktop: '100%',
  }),
  flexDirection: Platform.OS === 'web' ? undefined : 'row',
  flexWrap: Platform.OS === 'web' ? undefined : 'wrap',
  justifyContent: 'flex-start',
  padding: getResponsiveValue({
    mobile: 5,
    tablet: 0,
    laptop: 0,
    desktop: 0,
  }),
  maxHeight: 'none',
  overflowY: 'auto',
 },
 reportGrid: {
  display: Platform.OS === 'web' ? 'grid' : undefined,
  gridTemplateColumns: getResponsiveValue({
    mobile: 'repeat(1, 1fr)',
    tablet: 'repeat(2, 1fr)',
    laptop: 'repeat(3, 1fr)',
    desktop: 'repeat(3, 1fr)',
  }),
  gap: getResponsiveValue({
    mobile: 10,
    tablet: 15,
    laptop: 15,
    desktop: 15,
  }),
  width: getResponsiveValue({
    mobile: '95%',
    tablet: '95%',
    laptop: '100%',
    desktop: '100%',
  }),
  flexDirection: Platform.OS === 'web' ? undefined : 'row',
  flexWrap: Platform.OS === 'web' ? undefined : 'wrap',
  justifyContent: 'flex-start',
  padding: getResponsiveValue({
    mobile: 10,
    tablet: 0,
    laptop: 0,
    desktop: 0,
  }),
  maxHeight: getResponsiveValue({
    mobile: 400,
    tablet: 400,
    laptop: 'none',
    desktop: 'none',
  }),
  overflowY: 'auto',
 },
 reportCard: {
  backgroundColor: '#434252',
  borderRadius: 10,
  padding: 15,
  marginBottom: 15,
  width: '100%',
  borderWidth: 1,
  borderColor: 'rgba(255, 255, 255, 0.1)',
  ...(Platform.OS === 'web' ? { boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' } : {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  }),
  overflow: 'hidden',
 },
 reportHeader: {
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 10,
  padding: 10,
  borderBottomWidth: 1,
  borderBottomColor: 'rgba(255, 255, 255, 0.1)',
 },
 venueName: {
  color: '#ffffff',
  fontSize: 14,
  fontFamily: 'VastagoGrotesk',
  fontWeight: '600',
  marginBottom: 10,
  textAlign: 'center',
 },
 headerActions: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 10,
 },
 statusBadge: {
  paddingVertical: 4,
  paddingHorizontal: 8,
  borderRadius: 4,
  color: '#ffffff',
  fontSize: 10,
  fontFamily: 'VastagoGrotesk',
  fontWeight: '500',
  textAlign: 'center',
 },
 reportContent: {
  padding: 10,
 },
 detailText: {
  color: '#ffffff',
  fontSize: 12,
  fontFamily: 'VastagoGrotesk',
  marginBottom: 5,
 },
 venueCard: {
  backgroundColor: '#434252',
  borderRadius: 10,
  marginBottom: 20,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  borderWidth: 1,
  borderColor: 'rgba(255, 255, 255, 0.1)',
  ...(Platform.OS === 'web' ? { boxShadow: '0 2px 4px rgba(0,0,0,0.1)' } : {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  }),
 },
 venueCardContent: {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: getResponsiveValue({
    mobile: 40,
    tablet: 40,
    laptop: 50,
    desktop: 50,
  }),
 },
 venueCardImage: {
  width: '100%',
  aspectRatio: getResponsiveValue({
    mobile: 4.5/3,
    tablet: 4.5/3,
    laptop: 8/5,
    desktop: 8/5,
  }),
  minHeight: getResponsiveValue({
    mobile: 100,
    tablet: 120,
    laptop: 140,
    desktop: 140,
  }),
  position: 'relative',
 },
 venueCardTitle: {
  color: '#ffffff',
  fontSize: getResponsiveValue({
    mobile: 11,
    tablet: 12,
    laptop: 14,
    desktop: 16,
  }),
  fontFamily: 'VastagoGrotesk',
  fontWeight: getResponsiveValue({
    mobile: '400',
    tablet: '400',
    laptop: '600',
    desktop: '600',
  }),
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  marginBottom: 5,
 },
 venueCardLocation: {
  color: '#ffffff',
  fontSize: getResponsiveValue({
    mobile: 9,
    tablet: 10,
    laptop: 12,
    desktop: 14,
  }),
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  fontFamily: 'VastagoGrotesk',
  opacity: 0.8,
 },
 tourCard: {
  backgroundColor: '#434252',
  borderRadius: 10,
  padding: 15,
  marginBottom: 15,
  width: '100%',
  borderWidth: 1,
  borderColor: 'rgba(255, 255, 255, 0.1)',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
 },
 tourCardTitle: {
  color: '#ffffff',
  fontSize: 18,
  fontFamily: 'VastagoGrotesk',
  fontWeight: '600',
  marginBottom: 8,
 },
 tourCardInfo: {
  color: '#ffffff',
  fontSize: 14,
  fontFamily: 'VastagoGrotesk',
  opacity: 0.8,
  marginBottom: 5,
 },
 mediaPreviewContainer: {
  backgroundColor: '#434252',
  borderRadius: 10,
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  aspectRatio: 1,
  maxHeight: 180,
  marginBottom: 10,
  borderWidth: 1,
  borderColor: 'rgba(255, 255, 255, 0.1)',
  ...(Platform.OS === 'web' ? { boxShadow: '0 2px 4px rgba(0,0,0,0.1)' } : {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  }),
 },
 mediaPreviewImage: {
  width: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  height: '100%',
  objectFit: 'cover',
 },
 mediaPreviewText: {
  color: '#ffffff',
  fontFamily: 'VastagoGrotesk',
  fontSize: 14,
  marginBottom: 5,
  textAlign: 'center',
 },
 mediaAddButton: {
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
 },
 saveButton: {
  backgroundColor: '#4a90e2',
  paddingHorizontal: 12,
  paddingVertical: 8,
  borderRadius: 6,
  alignItems: 'center',
  justifyContent: 'center',
 },
 saveButtonText: {
  color: '#ffffff',
  fontSize: 12,
  fontWeight: '600',
 },
 dropdownContainer: {
  position: 'relative',
  width: '100%',
  zIndex: 10000,
 },
 dropdownButton: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: '#434252',
  padding: 12,
  borderRadius: 8,
  borderWidth: 1,
  borderColor: 'rgba(255, 255, 255, 0.1)',
  zIndex: 10001,
 },
 dropdownButtonText: {
  fontSize: 14,
  fontFamily: 'VastagoGrotesk',
  flex: 1,
 },
 dropdownList: {
  position: 'absolute',
  top: '100%',
  left: 0,
  right: 0,
  backgroundColor: '#434252',
  borderWidth: 1,
  borderColor: 'rgba(255, 255, 255, 0.1)',
  borderRadius: 8,
  marginTop: 5,
  overflow: 'hidden',
  zIndex: 1000,
  ...(Platform.OS === 'web' && {
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
  })
 },
 dropdownItem: {
  paddingVertical: 12,
  paddingHorizontal: 16,
  borderBottomWidth: 1,
  borderBottomColor: 'rgba(255, 255, 255, 0.1)',
  ...(Platform.OS === 'web' && {
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'rgba(74, 144, 226, 0.05)'
    }
  })
 },
 dropdownItemText: {
  fontSize: 14,
  fontFamily: 'VastagoGrotesk',
  textAlign: 'left',
 },
}); 